module.exports = "/_next/static/images/InternalSecurity-9428ed5e944f54c057c89abc3791e4e1.webp";